// ✅ Full ListProduct component with right-slide filter modal, close icon, search, category, sorting, and new date filters

import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "./Config";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faTimes, faSliders, faClose } from "@fortawesome/free-solid-svg-icons";
import { CountdownTimer } from "../components/CountDownTimer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ListProduct.css";
import UserReviewInfo from "../components/UserReviewInfo";
import { FaMapMarkerAlt } from "react-icons/fa";
import { formatDate } from "../components/dateUtils";

export default function ListProduct() {
  const { id } = useParams();
  const [productstype, setProductstype] = useState(id);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  
  const [sortOrder, setSortOrder] = useState(() => {
    return localStorage.getItem("sortOrder") || ""; // default empty string
  });
  const [sortBy, setSortBy] = useState(() => {
    return localStorage.getItem("sortBy") || "latest"; // default latest
  });
  const [dateFilter, setDateFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [categoryFilters, setCategoryFilters] = useState(() => {
    const saved = localStorage.getItem("categoryFilters");
    return saved ? JSON.parse(saved) : [];
  });
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const itemsPerPage = 8;

  const [categoryList, setcategoryList] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_category.php?t=${Date.now()}`)
      .then((res) => {
        //  console.log("Full response:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          const titles = res.data.data.map((cat) => cat.title);
          setcategoryList(titles);
          //  console.log("category titles:", titles);
        } else {
          console.warn("API success true, but data is not array");
          setcategoryList([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setcategoryList([]);
      });
  }, []);

  const toggleCategory = (category) => {
    setCategoryFilters((prev) => {
      const updated = prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category];

      console.log("SETTING LS:", updated);
      localStorage.setItem("categoryFilters", JSON.stringify(updated));

      return updated;
    });
  };



  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        let endpoint = `${BASE_URL}/all_items.php?t=${Date.now()}`;

        // --- Choose endpoint based on productstype ---
        if (productstype === "closingsoon") {
          endpoint = `${BASE_URL}/closing_soon.php?type=all&t=${Date.now()}`;
        } else if (productstype === "newly") {
          endpoint = `${BASE_URL}/newly_add.php?type=all&t=${Date.now()}`;
        } else if (productstype === "nowon") {
          endpoint = `${BASE_URL}/no_wins.php?type=all&t=${Date.now()}`;
        } else if (productstype === "mostactive") {
          endpoint = `${BASE_URL}/most_active.php?type=all&t=${Date.now()}`;
        }

        const response = await axios.get(endpoint);

        // console.log("data", response);

        if (response.data.success) {
          let filtered = [];
          if (productstype === "closingsoon") {
            filtered = [...response.data.closing_soon];
            filtered.sort(
              (a, b) => new Date(a.closing_time) - new Date(b.closing_time)
            );
          } else if (productstype === "newly") {
            filtered = [...response.data.new_add];
          } else if (productstype === "nowon") {
            filtered = [...response.data.no_win];
          } else if (productstype === "mostactive") {
            filtered = [...response.data.most_active];
          }
          const now = Date.now();

          // --- Date filters ---
          if (dateFilter !== "all") {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            filtered = filtered.filter((p) => {
              const closingTime = new Date(p.closing_time).getTime();

              if (dateFilter === "today") {
                const tomorrow = new Date(today);
                tomorrow.setDate(today.getDate() + 1);
                return (
                  closingTime >= today.getTime() &&
                  closingTime < tomorrow.getTime()
                );
              }

              if (dateFilter === "yesterday") {
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - 1);
                return (
                  closingTime >= yesterday.getTime() &&
                  closingTime < today.getTime()
                );
              }

              if (dateFilter === "7" || dateFilter === "30") {
                const daysAgo = new Date(today);
                daysAgo.setDate(today.getDate() - parseInt(dateFilter));
                return closingTime >= daysAgo.getTime() && closingTime <= now;
              }

              return true;
            });
          }

          // --- Search filter ---
          if (searchQuery.trim()) {
            filtered = filtered.filter((p) =>
              p.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
          }

          // --- Category filter ---
          if (categoryFilters.length > 0) {
            filtered = filtered.filter((p) =>
              categoryFilters.includes(p.category)
            );
          }

          // --- Sorting ---
          if (sortBy === "latest") {
            filtered.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
          } else if (sortBy === "oldest") {
            filtered.sort(
              (a, b) => new Date(a.created_at) - new Date(b.created_at)
            );
          }

          if (sortOrder === "asc") {
            filtered.sort(
              (a, b) =>
                parseFloat(a.current_price || a.desired_price) -
                parseFloat(b.current_price || b.desired_price)
            );
          } else if (sortOrder === "desc") {
            filtered.sort(
              (a, b) =>
                parseFloat(b.current_price || b.desired_price) -
                parseFloat(a.current_price || a.desired_price)
            );
          }

          setProducts(filtered);
          //  console.log("Filtered", filtered);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [
    productstype,
    sortOrder,
    sortBy,
    dateFilter,
    searchQuery,
    categoryFilters,
  ]);

  // Additional logic: pagination, bookmarking, rendering UI

  const pageNumbers = Array.from(
    { length: Math.ceil(products.length / itemsPerPage) },
    (_, i) => i + 1
  );
  const paginated = products.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [bookmarks, setBookmarks] = useState([]);
  const user_id = Cookies.get("user_id");
  const username = Cookies.get("username");
  const [relistuser, setrelistuser] = useState([]);

  // Item Get Relist Function
  useEffect(() => {
    const relistuser = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/get_relist_user.php?t=${Date.now()}`
        );

        //   console.log("Relist User", response.data);

        if (response.data.success) {
          setrelistuser(response.data);
          setLoading(false);
        } else {
          setrelistuser([]);
        }
      } catch (error) {
        console.error("Failed to fetch relist user", error);
        setrelistuser([]);
      }
    };

    const intervalId = setInterval(relistuser, 3000); // ✅ Call every 1 second

    return () => clearInterval(intervalId);
  }, []);

  const fetchBookmarks = async () => {
    if (!user_id) {
      console.error("User ID not found in cookies.");

      return;
    }
    try {
      const res = await fetch(
        `${BASE_URL}/all_fav_item.php?id=${user_id}&t=${Date.now()}`,
        {
          cache: "no-store",
        }
      );

      //  console.log(res);
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      //   console.log("Fetched data:", data);

      if (data.success) {
        setBookmarks(data.data);
      } else {
        setBookmarks([]);
      }
    } catch (err) {
      console.error("Error fetching bookmarks:", err);
    }
  };

  const [relistloading, setRelistLoading] = useState({});

  const relist = async (product_id: number, product_user_id: number) => {
    if (!user_id) {
      toast.warning("Login Required");
      return;
    }

    if (product_user_id === user_id) {
      toast.warning("You can't make a request on your own product.");
      return;
    }

    // ✅ Only this product’s loading = true
    setRelistLoading((prev) => ({ ...prev, [product_id]: true }));

    const response = {
      product_id,
      product_user_id,
      user_id,
    };

    // console.log("Sending data:", response);

    try {
      const res = await axios.post(`${BASE_URL}/relist_request.php`, response, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("Checking", res);

      if (res.data.success) {
        toast.success("Request sent to seller!");
        fetchBookmarks(); // refresh UI
      } else {
        toast.warning(res.data.message);
        fetchBookmarks();
      }
    } catch (error) {
      console.error(error);
      toast.warning("Server Error, Try Again!");
    } finally {
      // ✅ Turn off only this product’s loading
      setRelistLoading((prev) => ({ ...prev, [product_id]: false }));
    }
  };

  const [favloading, setfavloading] = useState(false);
  const addToFavorite = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required"); // use warning instead of success
      //  console.log("first");
      return;
    }

    const response = {
      id: id,
      username: username,
      user_id: user_id,
    };
    // console.log("Sending data:", response);

    setfavloading((prev) => ({ ...prev, [id]: true }));
    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=add`,
        response,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // console.log(res);
      if (res.data.success) {
        // setToastMessage(res.data.message || "Added!");
        toast.success("Add To WishList !");
        // setToastStatus(true);

        fetchBookmarks();
      } else {
        // toast.success("Something went wrong.");
        toast.warning(res.data.message);
        //setToastMessage();
        //  setToastStatus(true);

        fetchBookmarks();
      }

      setfavloading(false);
    } catch (error) {
      console.error(error);
      // setToastMessage("Server error. Try again.");
      setfavloading(false);
    }

    //  setToastStatus(false);
  };

  const removefav = async (id: string) => {
    if (!user_id) {
      toast.warning("Login Required"); // use warning instead of success
      console.log("first");
      return;
    }

    const response = {
      id,
      username,
      user_id,
    };

    // console.log(response);

    setfavloading((prev) => ({ ...prev, [id]: true }));

    try {
      const res = await axios.post(
        `${BASE_URL}/add_favorite.php?type=remove`,
        response
      );

      // console.log(res);
      if (res.data.success) {
        toast.error("Removed from favorites !", { toastId: "bid-removed" });

        fetchBookmarks();
      } else {
        toast.warning("Something went wrong.");
        // setToastStatus(true);

        fetchBookmarks();
      }

      setfavloading(true);
    } catch (error) {
      console.error(error);
      toast.success("Server error. Try again.");
      setfavloading(true);
    }

    //  setToastStatus(false);
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const [buyNowLimit, setBuyNowLimit] = useState(0); // number instead of array

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_company_detail.php?type=buy_now&t=${Date.now()}`)
      .then((res) => {
        // console.log("Full response:", res.data);
        if (
          res.data.success &&
          Array.isArray(res.data.data) &&
          res.data.data.length > 0
        ) {
          setBuyNowLimit(Number(res.data.data[0].number)); // store number directly
        } else {
          console.warn("API success true, but data is not array");
          setBuyNowLimit(0);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setBuyNowLimit(0);
      });
  }, []);


  const handleSortByChange = (value) => {
    setSortBy(value);
    localStorage.setItem("sortBy", value);
  };
  const handleSortOrderChange = (value) => {
    setSortOrder(value);
    localStorage.setItem("sortOrder", value);
  };

  const clearAllCategories = () => {
    setCategoryFilters([]); // state clear
    localStorage.removeItem("categoryFilters"); // localStorage remove
  };

  const clearOrderby = () => {
    setSortOrder([]); // state clear
    localStorage.removeItem("sortOrder"); // localStorage remove
  };

  const clearShortby = () => {
    setSortBy("");
    localStorage.removeItem("sortBy"); // localStorage remove
  };


  return (
    <>
      <Navbar />
      <ToastContainer />

      {/* Filter Sidebar */}
      <div
        className="filtersidebar"
        style={{
          position: "fixed",
          top: 0,
          right: showFilter ? 0 : "-100%",
          width: "300px",
          height: "100%",
          backgroundColor: "#fff",
          boxShadow: "-2px 0 10px rgba(0,0,0,0.2)",
          zIndex: 99999999999,
          transition: "right 0.3s ease-in-out",
          padding: "1rem",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Filters</h4>
          <FontAwesomeIcon
            icon={faTimes}
            style={{ cursor: "pointer" }}
            onClick={() => setShowFilter(false)}
          />
        </div>

        <input
          type="text"
          placeholder="Search here..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: "100%",
            padding: "8px",
            margin: "10px 0",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
        />

        <h5 style={{ marginTop: "15px" }}>Category</h5>
        {categoryList.map((cat) => (
          <label key={cat} style={{ display: "block", marginLeft: "10px" }}>
            <input
              type="checkbox"
              style={{ width: "18px", height: "18px" }}
              checked={categoryFilters.includes(cat)}
              onChange={() => toggleCategory(cat)}
            />{" "}
            {cat}
          </label>
        ))}

        <div style={{ marginTop: "15px", position: "relative" }}>
          <h5
            style={{
              position: "absolute",
              top: "4px",
              left: "15px",
              fontSize: "12px",
              background: "white",
            }}
          >
            Sort By
          </h5>
          <select
            value={sortBy}
            onChange={(e) => handleSortByChange(e.target.value)}

            style={{
              width: "100%",
              padding: "15px 10px 8px 10px",
              margin: "10px 0",
              border: "1px solid #ccc",
              borderRadius: "5px",
            }}
          >
            <option value="latest">Latest</option>
            <option value="oldest">Oldest</option>
          </select>
        </div>

        <div style={{ marginTop: "15px", position: "relative" }}>
          <h5
            style={{
              position: "absolute",
              top: "4px",
              left: "15px",
              fontSize: "12px",
              background: "white",
            }}
          >
            Sort Order
          </h5>
          <select
            style={{
              width: "100%",
              padding: "15px 10px 8px 10px",
              margin: "10px 0",
              border: "1px solid #ccc",
              borderRadius: "5px",
              outline: "none",
            }}
            value={sortOrder}
            onChange={(e) => handleSortOrderChange(e.target.value)}
          >
            <option value="asc">Price: Low to High</option>
            <option value="desc">Price: High to Low</option>
          </select>
        </div>

        <div style={{ marginTop: "15px", position: "relative" }}>
          <h5
            style={{
              position: "absolute",
              top: "4px",
              left: "15px",
              fontSize: "12px",
              background: "white",
              outline: "none",
            }}
          >
            Closing In
          </h5>
          <select
            style={{
              width: "100%",
              padding: "15px 10px 8px 10px",
              margin: "10px 0",
              border: "1px solid #ccc",
              borderRadius: "5px",
              outline: "none",
            }}
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="7">Last 7 Days</option>
            <option value="30">Last 30 Days</option>
          </select>
        </div>
      </div>

      {/* Product List */}
      <div className="page-settings">
        <div className="container">
          <div className="row">
            <div
              style={{
                padding: "1rem 2rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}

            >
              <p style={{ margin: "0px" }}>
                Showing{" "}
                {paginated.length > 0
                  ? `${(currentPage - 1) * itemsPerPage + 1}–${(currentPage - 1) * itemsPerPage + paginated.length
                  }`
                  : "0"}{" "}
                of {products.length} results
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>


                <div className="filter_category_section_desk">

                  {sortBy.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearShortby()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Short By
                    </button>
                  )}


                  {sortOrder.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearOrderby()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Order By
                    </button>
                  )}

                  {categoryFilters.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearAllCategories()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Categories
                    </button>
                  )}
                </div>

                <button
                  className="filtersidebar"
                  onClick={() => setShowFilter(true)}
                  style={{
                    padding: "8px 16px",
                    background: "rgba(0, 123, 255, 0)",
                    color: "Black",
                    border: "none",
                    borderRadius: "6px",
                  }}
                >
                  <FontAwesomeIcon icon={faSliders} /> Filter
                </button>
              </div>
            </div>

                <div className="filter_category_section_mobile">

                  {sortBy.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearShortby()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Short By
                    </button>
                  )}


                  {sortOrder.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearOrderby()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Order By
                    </button>
                  )}

                  {categoryFilters.length > 0 && (
                    <button
                      className="filtersidebar"
                      onClick={() => clearAllCategories()}
                      style={{
                        padding: "5px 15px",
                        background: "rgb(230 171 40 / 7%)",
                        color: "Black",
                        border: "1px solid black",
                        borderRadius: "50px",
                        fontWeight: "600",
                        fontSize: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px"
                      }}
                    >
                      <FontAwesomeIcon icon={faClose} style={{ fontSize: "15px" }} />
                      Categories
                    </button>
                  )}
                </div>
            {loading ? (
              <div
                className="loading-overlay"
                style={{
                  height: "550px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div className="dot-spinner">
                  {[...Array(8)].map((_, i) => (
                    <div key={i} className="dot-spinner__dot"></div>
                  ))}
                </div>
              </div>
            ) : paginated.length > 0 ? (
              paginated.map((product) => (
                <div
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-6 p-sm-0 p-0 m-0 product-list"
                  key={product.id}
                >
                  <div className="auction-card">
                    <div
                      className="auction-card-img-wrap"
                      style={{ position: "relative", overflow: "hidden" }}
                    >
                      <Link to={`/detail/${product.id}`} className="card-img">
                        <img
                          src={
                            product.photo
                              ? `${BASE_URL}/${product.photo
                                .split(",")[0]
                                .trim()}`
                              : `${BASE_URL}/uploads/logo/icon.png`
                          }
                          alt=""
                        />
                      </Link>
                      <ul className="bookmark_icon">
                        <li>
                          {favloading[product.id] ? (
                            <span className="fav-spinner"></span>
                          ) : (
                            <Link
                              to="#/"
                              onClick={() => {
                                bookmarks.some(
                                  (items) => items.id === product.id
                                )
                                  ? removefav(product.id)
                                  : addToFavorite(product.id);
                              }}
                            >
                              {/* Eye Icon */}
                              <FontAwesomeIcon
                                icon={faHeart}
                                style={{
                                  color: bookmarks.some(
                                    (items) => items.id === product.id
                                  )
                                    ? "#F2B42A"
                                    : "",
                                  borderRadius: "50%",
                                }}
                              />
                            </Link>
                          )}
                        </li>
                      </ul>
                      {product.membership_type !== "Basic" && (
                        <p
                          className="tag"
                          style={{
                            position: "absolute",
                            top: 15,
                            left: "-23px",
                            margin: 0,
                            background:
                              product.membership_type === "Gold"
                                ? "#F2B42A"
                                : product.membership_type === "Silver"
                                  ? "#C0C0C0"
                                  : "#ffffff", // fallback
                            padding: "0px 22px",
                            textAlign: "center",
                            borderRadius: "2px",
                            color: "black",
                            fontWeight: 800,
                            transform: "rotate(309deg)"
                          }}
                        >
                          {product.membership_type}
                        </p>
                      )}
                      <CountdownTimer closingTime={product.closing_time} />
                    </div>
                    <div className="auction-card-content">
                      {/* <UserReviewInfo userId={item.user_id} /> */}
                      <div
                        className="price-and-code-area"
                        style={{ marginBottom: "5px" }}
                      >
                        <div className="price">
                          <span
                            style={{
                              fontSize: "15px",
                              color: "#91948F",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              gap: "1px",
                            }}
                          >
                            {" "}
                            <FaMapMarkerAlt
                              style={{ color: "#91948F", fontSize: "14px" }}
                            />{" "}
                            {product.city}{" "}
                          </span>
                        </div>
                        <div className="code"># {product.id}</div>
                      </div>
                      {/* <div className="details_buyer">
                        {formatDate(product.closing_time)}
                      </div> */}
                      <h6 className="product_title">
                        <Link to={`/detail/${product.id}`}>
                          {product.title}
                        </Link>
                      </h6>
                      <div className="price-and-code-area">
                        <div className="price">
                          <span>Current Bid at:</span>
                          <strong>{product.current_price || "0.00"} SAR</strong>
                        </div>

                        {Number(product.current_price) /
                          Number(product.buy_now) >=
                          buyNowLimit ? (
                          ""
                        ) : Number(product.buy_now) == 0 ? (
                          ""
                        ) : (
                          <div className="price">
                            <span>Buy Now at:</span>
                            <strong>{Number(product.buy_now)} SAR</strong>
                          </div>
                        )}
                      </div>
                    </div>

                    {new Date(product.closing_time) < new Date() ? (
                      <div className="relise">
                        {relistloading[product.id] ? (
                          // 🌀 Show loader or loading text
                          <p
                            style={{
                              color: "#ff0505ff",
                              margin: 0,
                              fontWeight: "600",
                            }}
                          >
                            Requesting...
                          </p>
                        ) : relistuser?.data?.some(
                          (entry) =>
                            String(entry.user_id) === String(user_id) &&
                            String(entry.product_id) === String(product.id)
                        ) ? (
                          // ✅ If already applied
                          <p
                            style={{
                              color: "green",
                              fontWeight: "bold",
                              margin: "0",
                            }}
                          >
                            You applied for relist
                          </p>
                        ) : (
                          // 🖱️ Default button
                          <button
                            onClick={() => relist(product.id, product.user_id)}
                          >
                            Please Relist item again
                          </button>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <img
                  src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                  alt="No Data"
                  style={{ width: "300px", mixBlendMode: "darken" }}
                />
              </div>
            )}
          </div>

          {/* Pagination */}
          <div className="pagination-container">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="page-btn"
            >
              &lt; Previous
            </button>
            {pageNumbers.map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`page-btn ${currentPage === page ? "active" : ""}`}
              >
                {page}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, pageNumbers.length))
              }
              disabled={currentPage === pageNumbers.length}
              className="page-btn"
            >
              Next &gt;
            </button>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
